var React = require('react');

function Enlarge (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"16","fill":"#e5e5e5","key":0}),React.createElement("path",{"d":"M12,10.939,5.636,4.575,4.575,5.636,10.939,12,4.575,18.364l1.061,1.061L12,13.061l6.364,6.364,1.061-1.061L13.061,12l6.364-6.364L18.364,4.575Z","transform":"translate(16 -0.971) rotate(45)","fill":"#fff","key":1})]);
}

Enlarge.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Enlarge;

Enlarge.default = Enlarge;
